import {api2Endpoint} from 'app/config/apiConfig'
import errorNotify from 'app/hooks/api/utils/errorNotify'
import {queryDefaults} from 'app/react-query'
import {useQuery} from 'react-query'
import {getData} from '../api/useGetData'
import {announceSend} from '../api/utils/announce'

export function useGetStripePrices() {
  return useQuery({
    queryKey: [`stripe_product_plans`],
    queryFn: async () => {
      try {
        const route = `std/stripe/prices`
        announceSend('get', route)
        const retval = await getData<any>(api2Endpoint(route))
        announceSend('get', route)
        return retval
      } catch (err) {
        errorNotify(err, 'Could not retrieve product plans')
      }
    },
    cacheTime: queryDefaults.cacheTime,
    staleTime: queryDefaults.staleTime,
    retry: queryDefaults.retry,
  })
}
